import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const PortfolioCard = ({ project, delay = 0 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => {
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, []);

  const handleProjectClick = () => {
    // Scroll to top when navigating to project details
    window.scrollTo(0, 0);
  };

  return (
    <div 
      ref={cardRef}
      className={`portfolio-card ${isVisible ? 'fade-in' : ''}`}
      style={{
        animationDelay: `${delay}ms`
      }}
    >
      <div className="portfolio-img" style={{backgroundColor: project.imageColor}}>
        <i className={project.icon} style={{fontSize: '3rem'}}></i>
      </div>
      <div className="portfolio-content">
        <h3>{project.title}</h3>
        <p>{project.description}</p>
        <div className="tech-stack">
          {project.techStack.map((tech, index) => (
            <span key={index} className="tech-tag">{tech}</span>
          ))}
        </div>
        <div className="app-links">
          {project.appLinks && project.appLinks.map((link, index) => (
            <a 
              key={index}
              href={link.url} 
              className="app-link" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <i className={link.icon}></i> {link.platform}
            </a>
          ))}
          <Link 
            to={`/project/${project.id}`} 
            className="btn btn-secondary"
            onClick={handleProjectClick}
          >
            View Details
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PortfolioCard;